import { render, staticRenderFns } from "./CreateLetterAndCourse.vue?vue&type=template&id=a4032ec4&scoped=true&"
import script from "./CreateLetterAndCourse.vue?vue&type=script&lang=js&"
export * from "./CreateLetterAndCourse.vue?vue&type=script&lang=js&"
import style0 from "./CreateLetterAndCourse.vue?vue&type=style&index=0&id=a4032ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4032ec4",
  null
  
)

export default component.exports